import type { PlateGroup } from './types';

/**
 * Each kind's family, without loading the kinds themselves: the app shell
 * decides what is drawn from this, and the models load with the pages that
 * draw them. A test keeps it equal to the models' own groups.
 */
export const KIND_GROUP: Readonly<Record<string, PlateGroup>> = {
  card: 'Text',
  exhibit: 'Text',
  steps: 'Text',
  prompt: 'Text',
  note: 'Text',
  pullquote: 'Text',
  definitions: 'Text',
  image: 'Media',
  gallery: 'Media',
  embed: 'Media',
  audio: 'Media',
  video: 'Media',
  table: 'Data',
  chart: 'Data',
  scatter: 'Data',
  histogram: 'Data',
  heatmap: 'Data',
  calendar: 'Data',
  stats: 'Data',
  timeline: 'Data',
  decisions: 'Data',
  live: 'Data',
  flowchart: 'Diagram',
  sequence: 'Diagram',
  'class-diagram': 'Diagram',
  'state-diagram': 'Diagram',
  'entity-diagram': 'Diagram',
  gantt: 'Diagram',
  requirements: 'Diagram',
  c4: 'Diagram',
  architecture: 'Diagram',
  'block-diagram': 'Diagram',
  packet: 'Diagram',
  kanban: 'Diagram',
  sankey: 'Diagram',
  treemap: 'Diagram',
  journey: 'Diagram',
  mindmap: 'Diagram',
  'git-graph': 'Diagram',
  venn: 'Diagram',
  fishbone: 'Diagram',
  wardley: 'Diagram',
  cynefin: 'Diagram',
  'event-model': 'Diagram',
  swimlane: 'Diagram',
  'agent-flow': 'Diagram',
  'use-case': 'Diagram',
  'file-tree': 'Diagram',
  grammar: 'Diagram',
  slides: 'Interactive',
  widget: 'Interactive',
  flashcards: 'Interactive',
  tabs: 'Interactive',
  quiz: 'Interactive',
};
